var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-tabs hidden-sm hidden-xs",class:_vm.navClasses,attrs:{"data-init-reponsive-tabs":"dropdownfx"}},_vm._l((_vm.headings),function(tab,index){return _c('li',{class:_vm.manageActiveClass(index),on:{"click":function($event){$event.preventDefault();return _vm.$emit('click', index)}}},[_c('a',{attrs:{"aria-expanded":"false"}},[_c('span',[_vm._v(_vm._s(tab))])])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e74695b","hasScoped":false,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Tabs/Navigation.vue
// module id = 1735
// module chunks = 0